module.exports = __webpack_public_path__ + "static/media/unity.368a1f10.png";